import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SpellcheckIcon(props: IconProps) {
    return <Icon {...props} iconKey={"spellcheck"}/>
}
